import { t } from "../../i18n";
import { SeoMetadataEditor } from "../seo/SeoMetadataEditor";
import { CasinoCategorySeoDraft } from "./casinoCategorySeoDraft";
import { categoryFallbackInputs } from "./casinoSeoFallbackInputs";
import { casinoCategorySeoDisplayUrl } from "./casinoSeoUrl";
import { SeoDraftEditorShell } from "./SeoDraftEditorShell";

export interface CasinoCategorySeoEditorProps {
  draft: CasinoCategorySeoDraft;
  /** Undefined until the category has been saved once. */
  categoryId?: number;
  categoryName?: string;
}

/** A casino category's SEO editor. It loads the category's SEO into the draft its host saves after the category. */
export function CasinoCategorySeoEditor({ draft, categoryId, categoryName }: CasinoCategorySeoEditorProps): JSX.Element {
  return (
    <div data-testid="seo-category-section">
      <h4>{t("admin.seo.heading", undefined, "SEO")}</h4>
      <SeoDraftEditorShell
        draft={draft}
        targetId={categoryId}
        saveFirstMessage={t("admin.seo.save-category-first", undefined, "Save the category first to add SEO.")}
        saveFirstTestId="seo-category-save-first"
        testIdPrefix="seo-category"
        renderFields={(context) => (
          <SeoMetadataEditor
            locales={context.locales ?? []}
            values={draft.getValues()}
            fallbackInputs={categoryFallbackInputs(context)}
            cmsAvailable={context.cmsAvailable ?? false}
            displayUrl={casinoCategorySeoDisplayUrl({ id: categoryId, name: categoryName })}
            onChange={(locale, field, value) => draft.setField(locale, field, value)}
            testIdPrefix="seo-category"
          />
        )}
      />
    </div>
  );
}
